import { Button } from "@chakra-ui/react";
import {
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenu as UI_DropdownMenu,
} from "components/ui/dropdown-menu";
import { toast } from "components/ui/use-toast";
import Edit from "@/assets/icons/edit";
import { useDialogModal } from "@/hook/handle-modal/hooks/actions";
import Update from "../../update";
import { useReactivateRegionalMutation } from "@/services/regional";
import { Trash, RotateCcw } from "lucide-react";
import { IRegional } from "src/@types/regional";
import { StatusEnum } from "@/enum/status";
import { MESSAGES } from "../../utils/messages";

function DropdownMenuComponent({
  trigger,
  row,
  onOpenDeactivateDialog,
}: {
  trigger: React.ReactNode;
  row: IRegional;
  onOpenDeactivateDialog: (row: IRegional) => void;
}) {
  const { handleModal } = useDialogModal();

  const [reactivateRegional, { isLoading: isReactivating }] =
    useReactivateRegionalMutation();

  const handleReactivate = async () => {
    try {
      await reactivateRegional(+row?.id).unwrap();
      
      toast(MESSAGES.REACTIVATE.SUCCESS);
    } catch (error) {
      console.error(error);
      
      toast(MESSAGES.REACTIVATE.ERROR);
    }
  };

  const openModalUpdate = () => {
    handleModal({
      isOpen: true,
      element: <Update row={row} />,
      title: "Editar Regional",
    });
  };

  return (
    <>
      <UI_DropdownMenu>
        <DropdownMenuTrigger asChild>{trigger}</DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {/* Editar */}
          <DropdownMenuItem
            style={{ cursor: "pointer" }}
            onClick={openModalUpdate}
          >
            <Button
              variant="link"
              className="pointer flex items-center justify-start gap-4"
            >
              <Edit color={"black"} size={13} />
              Editar
            </Button>
          </DropdownMenuItem>

          {/* Desativar */}
          {row.status === StatusEnum.ACTIVE && (
            <DropdownMenuItem asChild>
              <Button
                variant="link"
                className="pointer flex items-center justify-start gap-4"
                onClick={() => onOpenDeactivateDialog(row)}
              >
                <Trash color={"black"} size={13} />
                Desativar
              </Button>
            </DropdownMenuItem>
          )}

          {/* Reativar */}
          {row.status === StatusEnum.INACTIVE && (
            <DropdownMenuItem
              style={{ cursor: "pointer" }}
              onClick={handleReactivate}
            >
              <Button
                variant="link"
                className="pointer flex items-center justify-start gap-4"
                isLoading={isReactivating}
              >
                <RotateCcw color={"black"} size={13} />
                Reativar
              </Button>
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </UI_DropdownMenu>
    </>
  );
}

export default DropdownMenuComponent;